<div class="responsive-card">
  <div class="responsive-card-title" i18n>Account Details</div>
  <div *ngIf="isMandatoryRetirement" class="mandatory-retirement">
    <img
      class="mandatory-retirement-icon"
      [ngbTooltip]="mandatoryRetirementTooltip"
      [triggers]="'hover focus click'"
      [src]="'assets/icons/grey/Information Circle.svg'"
      alt=""
      tabindex="0"
      role="button"
      aria-label="Mandatory retirement information"
      i18n-aria-label />
    <span i18n>Mandatory retirement</span>
  </div>
  <div class="account-details-grid mt-4">
    <div *ngFor="let detail of accountDetails; trackBy: trackByLabel" class="detail-card">
      <div class="detail-label">{{ detail.label }}</div>
      <div class="detail-content">
        <div class="detail-value">{{ detail.value }}</div>
        <div *ngIf="detail.subtext" class="detail-subtext">{{ detail.subtext }}</div>
      </div>
    </div>
  </div>
  <div class="account-details-notes d-flex flex-column gap-3" *ngIf="useEntireBalance || smallPensionPayoutOptIn">
    <div class="account-details-note" i18n *ngIf="useEntireBalance">
      *Amount reflects full balance as of submission date. Final amount may vary based on effective date.
    </div>
    <div class="account-details-note" i18n *ngIf="smallPensionPayoutOptIn">
      **If the actual monthly benefit at purchase falls below the small pension threshold, the pension is paid out as a
      one-time lump sum rather than a lifetime monthly pension.
    </div>
  </div>
</div>
